import React, { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const APIAccessIcon = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 24 24"
      >
        <g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.8852 1.21662e-05C11.9518 -0.00647777 12.9987 0.287332 13.9063 0.847922C14.6496 1.30708 15.2748 1.92998 15.7359 2.66602C16.0507 2.61778 16.3691 2.59334 16.6882 2.59305C18.2839 2.56788 19.8246 3.17657 20.9724 4.28578C22.1216 5.39647 22.7827 6.91808 22.8103 8.51608C22.8105 8.52468 22.8105 8.53328 22.8103 8.54187C22.783 10.1401 22.122 11.662 20.9728 12.7729C19.825 13.8824 18.2842 14.4912 16.6883 14.466L6.41627 14.4641C5.05403 14.4846 3.73906 13.9644 2.75939 13.0174C1.77819 12.0689 1.21358 10.7697 1.18957 9.40524C1.18942 9.39692 1.18941 9.38858 1.18955 9.38025C1.20965 8.10186 1.70622 6.87702 2.58203 5.94554C3.32024 5.1604 4.28307 4.63136 5.33075 4.42537C5.58083 3.26311 6.19559 2.20479 7.09306 1.40953C8.13762 0.483916 9.48985 -0.0186258 10.8852 1.21662e-05ZM10.8713 1.49997C9.84722 1.48475 8.85442 1.85292 8.08787 2.53218C7.32131 3.21144 6.83637 4.15273 6.72826 5.17121C6.6901 5.53075 6.40086 5.81188 6.04038 5.83981C5.13824 5.9097 4.29466 6.31382 3.67484 6.97304C3.05787 7.62923 2.70683 8.49113 2.68958 9.39135C2.70981 10.3538 3.10951 11.2696 3.80193 11.9389C4.49735 12.6112 5.43115 12.9799 6.39823 12.9641L6.4106 12.9639L16.7071 12.9661C17.9076 12.9862 19.067 12.5289 19.9302 11.6944C20.7904 10.8629 21.2865 9.72489 21.3103 8.52909C21.2862 7.33346 20.7901 6.19569 19.9299 5.36438C19.0667 4.53008 17.9074 4.07275 16.7071 4.09294L16.6944 4.09316C16.3014 4.09312 15.9099 4.14097 15.5285 4.23586C15.1858 4.32114 14.83 4.15572 14.6743 3.83871C14.3272 3.13211 13.7878 2.5378 13.118 2.12409C12.4483 1.71038 11.6753 1.49407 10.8881 1.50003L10.8713 1.49997Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.2451 15.9661C20.6593 15.9661 20.9951 16.3019 20.9951 16.7161V23.2501C20.9951 23.6643 20.6593 24.0001 20.2451 24.0001C19.8309 24.0001 19.4951 23.6643 19.4951 23.2501V16.7161C19.4951 16.3019 19.8309 15.9661 20.2451 15.9661Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.1885 16.7161C18.1885 16.3019 18.5243 15.9661 18.9385 15.9661H21.5515C21.9657 15.9661 22.3015 16.3019 22.3015 16.7161C22.3015 17.1303 21.9657 17.4661 21.5515 17.4661H18.9385C18.5243 17.4661 18.1885 17.1303 18.1885 16.7161Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.1885 23.25C18.1885 22.8358 18.5243 22.5 18.9385 22.5H21.5515C21.9657 22.5 22.3015 22.8358 22.3015 23.25C22.3015 23.6642 21.9657 24 21.5515 24H18.9385C18.5243 24 18.1885 23.6642 18.1885 23.25Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.0967 19.886C11.5109 19.886 11.8467 20.2218 11.8467 20.636V23.25C11.8467 23.6642 11.5109 24 11.0967 24C10.6825 24 10.3467 23.6642 10.3467 23.25V20.636C10.3467 20.2218 10.6825 19.886 11.0967 19.886Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.3496 16.7161C10.3496 16.3019 10.6854 15.9661 11.0996 15.9661H13.0596C13.7783 15.9661 14.4676 16.2516 14.9759 16.7598C15.4841 17.268 15.7696 17.9573 15.7696 18.6761C15.7696 19.3948 15.4841 20.0841 14.9759 20.5923C14.4676 21.1005 13.7783 21.3861 13.0596 21.3861H11.0996C10.6854 21.3861 10.3496 21.0503 10.3496 20.6361V16.7161ZM11.8496 17.4661V19.8861H13.0596C13.3805 19.8861 13.6883 19.7586 13.9152 19.5317C14.1421 19.3047 14.2696 18.997 14.2696 18.6761C14.2696 18.3552 14.1421 18.0474 13.9152 17.8205C13.6883 17.5935 13.3805 17.4661 13.0596 17.4661H11.8496Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.56232 17.4819C4.2889 17.4819 4.02443 17.5793 3.81634 17.7567C3.60912 17.9333 3.47132 18.1777 3.42739 18.4464L2.69104 23.361C2.62967 23.7707 2.24783 24.053 1.83819 23.9916C1.42855 23.9302 1.14622 23.5484 1.2076 23.1388L1.94575 18.2121C2.04558 17.59 2.36382 17.0238 2.84333 16.6151C3.32284 16.2064 3.93227 15.9819 4.56232 15.9819C5.19237 15.9819 5.8018 16.2064 6.28131 16.6151C6.76082 17.0238 7.07902 17.59 7.17885 18.2121L7.18006 18.2196L7.91802 23.1386C7.97948 23.5482 7.69723 23.9301 7.2876 23.9916C6.87797 24.0531 6.49608 23.7708 6.43462 23.3612L5.69726 18.4464C5.65334 18.1778 5.51553 17.9333 5.3083 17.7567C5.10021 17.5793 4.83574 17.4819 4.56232 17.4819Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.54199 20.9629C1.54199 20.5487 1.87778 20.2129 2.29199 20.2129H6.83299C7.24721 20.2129 7.58299 20.5487 7.58299 20.9629C7.58299 21.3771 7.24721 21.7129 6.83299 21.7129H2.29199C1.87778 21.7129 1.54199 21.3771 1.54199 20.9629Z"
            fill="currentColor"
          />
        </g>
      </SvgIcon>
    );
  })
);
